import { apiClient } from './client';
import type { TeamOptionDto } from './hr-team';

/**
 * 근태 달력 — **「이번 달에 누가 자리를 비우나」** (2026-09-06 · 달력 판).
 *
 * 서버: `apps/chat-server/src/modules/hr/attendance-calendar.routes.ts` · 정본 C6.
 *
 * ★★★ **출근 · 미출근은 여기 없다.** 매일 · 모두에게 있는 값이라 칸마다 마흔 줄이 서고,
 *    그러면 정작 «비는 날»이 묻힌다. 하루의 값은 같은 화면의 **표**(`/hr/attendance/team`)가 맡는다.
 * ★ 권한은 팀 근태와 같다 — 팀장은 자기 팀, 전사는 전사를 보는 사람만(403) · 옛 서버는 404.
 */
export type CalendarItemKind = 'LEAVE' | 'TRIP';

export interface AttendanceCalendarItem {
  userId: string;
  name: string;
  kind: CalendarItemKind;
  /** 휴가면 종류(`annual`·`substitute` …), 출장이면 `business_trip`·`outside_work`. */
  type: string;
  /** 반차 · 반반차의 구간 `HH:mm` (S6 · 2026-09-16). 옛 기록 · 종일 · 옛 서버는 없거나 null. */
  startTime?: string | null;
  endTime?: string | null;
}

export interface AttendanceCalendarDay {
  /** `YYYY-MM-DD`. */
  date: string;
  /** 이 달의 날인가 — 앞뒤로 삐져나온 칸은 화면이 옅게 그린다. */
  inMonth: boolean;
  holiday: { name: string; isSubstitute: boolean } | null;
  items: AttendanceCalendarItem[];
}

export interface AttendanceCalendarDto {
  period: 'month' | 'week';
  date: string;
  from: string;
  to: string;
  /** 격자가 실제로 그리는 구간 — 앞뒤 달까지 물고 있다. */
  gridFrom: string;
  gridTo: string;
  teams: TeamOptionDto[];
  team: TeamOptionDto | null;
  scope: 'team' | 'company';
  days: AttendanceCalendarDay[];
  tzOffsetMinutes: number;
}

export async function fetchAttendanceCalendar(params: {
  period: 'month' | 'week';
  date?: string;
  scope?: 'team' | 'company';
  teamId?: string;
}): Promise<AttendanceCalendarDto> {
  const { data } = await apiClient.get<AttendanceCalendarDto>('/hr/attendance/calendar', { params });
  return data;
}
